function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClimateClock = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _View = require("../View");
var _Heading = require("../Heading");
var _Button = require("../Button");
var _SvgImage = require("../SvgImage");
var _styles = require("../../styles");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles2 = require("./styles");
var _Clock = require("./Images/Clock");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ClimateClock = exports.ClimateClock = (0, _react.memo)(function (_ref) {
  var containerStyle = _ref.containerStyle,
    title = _ref.title,
    linkLabel = _ref.linkLabel,
    linkUrl = _ref.linkUrl,
    linkOnPress = _ref.linkOnPress,
    years = _ref.years,
    months = _ref.months,
    _ref$unlimited = _ref.unlimited,
    unlimited = _ref$unlimited === void 0 ? false : _ref$unlimited;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _hasTitle = !!title;
  var _hasLink = !!linkLabel && (!!linkUrl || !!linkOnPress);
  var _hasYears = years !== null && years > 0;
  var _hasMonths = months !== null && months > 0;
  var _unlimited = years === null && months === null || unlimited;
  if (years === null && months === null && unlimited === false) return null;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.container, containerStyle],
    testID: "ClimateClock",
    children: [_hasTitle && (0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: 2,
      style: styles.title,
      children: title
    }), (0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.boxGroup,
      spacer: spacing.normal,
      children: [(0, _jsxRuntime.jsxs)(_View.View, {
        style: styles.clockGroup,
        children: [(0, _jsxRuntime.jsx)(_View.View, {
          style: styles.cloudsContainer,
          children: (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
            image: require("./Images/Clouds.svg"),
            style: styles.clouds,
            width: 202,
            height: 86
          })
        }), (0, _jsxRuntime.jsx)(_View.View, {
          style: styles.clockContainer,
          children: (0, _jsxRuntime.jsx)(_Clock.Clock, {
            style: styles.clock
          })
        })]
      }), (0, _jsxRuntime.jsxs)(_View.View, {
        style: styles.contentGroup,
        children: [_unlimited ? (0, _jsxRuntime.jsx)(_reactNative.Text, {
          textBreakStrategy: "simple",
          style: styles.unlimited,
          children: t('climateClock:unlimited')
        }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            textBreakStrategy: "simple",
            style: styles.prefix,
            children: t('climateClock:prefix')
          }), (0, _jsxRuntime.jsxs)(_View.View, {
            style: styles.calendar,
            spacer: spacing.l,
            children: [_hasYears && (0, _jsxRuntime.jsxs)(_View.View, {
              style: styles.calendarItem,
              children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                textBreakStrategy: "simple",
                style: styles.calendarItemValue,
                children: t('format:number', {
                  value: years
                })
              }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
                textBreakStrategy: "simple",
                style: styles.calendarItemLabel,
                children: t('climateClock:years')
              })]
            }), _hasMonths && (0, _jsxRuntime.jsxs)(_View.View, {
              style: styles.calendarItem,
              children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                textBreakStrategy: "simple",
                style: styles.calendarItemValue,
                children: t('format:number', {
                  value: months
                })
              }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
                textBreakStrategy: "simple",
                style: styles.calendarItemLabel,
                children: t('climateClock:months')
              })]
            })]
          }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
            textBreakStrategy: "simple",
            style: styles.suffix,
            children: t('climateClock:suffix')
          })]
        }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
          textBreakStrategy: "simple",
          style: styles.note,
          children: t('climateClock:note')
        })]
      })]
    }), _hasLink && (0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.brand,
      href: linkUrl,
      label: linkLabel,
      onPress: linkOnPress,
      containerStyle: styles.link
    })]
  });
});